module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/smoke-detector/smokeDetector.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/smoke-detector/smokeDetector.png
// module id = 628
// module chunks = 0